export default __webpack_public_path__ + "static/media/minerva-logo.7d0b5404.png";